import { axios } from "@/plugins/axios.js";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMasterLogs(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("/api/v1/master_logs", { params })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
